import { Button, Chip, Typography } from "@material-ui/core";
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from '@material-ui/lab';
import moment from "moment";
import React, { useEffect, useState } from "react";
import { getEnvVariable } from "../../../modules/environmentalList";
import { GetData } from "../../controls/helpers/requests";
import { createRequest, requestApi } from "../../controls/helpers/rest";
import { use } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const RegistrationsContainer = () => {
    const [registrations, setRegistrations] = useState([]);
    const params = useParams();

    useEffect(() => {
        // Fetch registrations
        const read = [
            {
                "url": getEnvVariable('MasterAdmin') + `/api/CompanyInternal/${getEnvVariable('ModuleKey')}/${params.Id}`,
                type: 'get'
            },
        ]
         Promise.all(read.map(each => requestApi(createRequest(each)))
        ).then(res => {
            let url = getEnvVariable('MasterAdmin') + `/api/SelfRegistration/Owner/GetAllCompanyRegistrationsData?page=1&pageSize=100&AccessId=${res[0].AccessId}`;
            GetData(url).then((response) => {
                if (response) {
                    let data = response;
                    if (data && data.length > 0) {
                        let registrations = data.map((item) => {
                            return {
                                date: item.UpdatedOn ? moment(item.UpdatedOn).format('MM/DD/YYYY') : moment(item.CreatedOn).format('MM/DD/YYYY'),
                                title: item.Title,
                                description: item.Description,
                                requestStatus: item.RegistrationStatus,
                                modules: item.RequestedModules || []
                            };
                        });
                        setRegistrations(registrations);
                    }
                }
            }
            )
        })
    }, []);

    const handleRequestModules = () => {
        window.open(getEnvVariable('AuthorizationScreen') + 'registrations/requestmodules?ENV=' + getEnvVariable('REACT_APP_PROFILE'), '_blank');
    };

    return (
        <>
            {getEnvVariable('AccessPortal') === 'E' && <Button className="float-end" variant="outlined" color="primary" onClick={() => { handleRequestModules() }}>Request Modules</Button>}
            <Timeline align="left">
                {registrations.map((registration, index) => (
                    <TimelineItem key={index} >
                        <TimelineSeparator>
                            <TimelineDot style={{ backgroundColor: registration.requestStatus === 'A' ? 'green' : (registration.requestStatus === 'R' || registration.requestStatus === 'D') ? 'red' : 'blue' }} />
                            {index < registrations.length - 1 && <TimelineConnector />}
                        </TimelineSeparator>
                        <TimelineContent>
                            <Typography variant="body2" color="textSecondary" className="float-end">
                                {registration.date}
                            </Typography>
                            <Typography variant="body1" component="div" color="textPrimary">
                                {registration.title}
                            </Typography>

                            <Typography variant="body2" color="textSecondary">
                                {registration.description}
                            </Typography>
                            {registration.modules.map((e, i) => (
                                <Chip key={i} variant="outlined" color="primary" size="small" title={e} label={e} />
                            ))}
                        </TimelineContent>
                    </TimelineItem>
                ))}
            </Timeline>
        </>
    );
};

export default RegistrationsContainer;